import React, { createContext, useContext, ReactNode } from "react";
import createClient, { Client } from "../services/Clients";
import { ServiceName } from "../environment/environment";
type ClientContextValue = {
  getClient: (serviceName: ServiceName) => Client;
};

const ClientContext = createContext<ClientContextValue | null>(null);

export const ClientProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const getClient = (serviceName: ServiceName) => createClient(serviceName);

  return (
    <ClientContext.Provider value={{ getClient }}>
      {children}
    </ClientContext.Provider>
  );
};

export const useClient = (serviceName: ServiceName): Client => {
  const context = useContext(ClientContext);
  if (!context) {
    throw new Error("useClient must be used within a ClientProvider");
  }
  return context.getClient(serviceName);
};
